<template>
  <el-dialog :visible.sync="showDialog" :show-close="false" width="400px">
    <div class="dialog-conainer">
      <div class="dialog-top">
        <div class="title">扫一扫立即下载</div>
        <div class="image-box" @click="showDialog = false">
          <img class="image" src="@/assets/icon_dialog_close.png" />
        </div>
      </div>
      <div class="qr-image">
        <img class="image" :src="itemData.qrcode" />
      </div>
      <div class="desc">{{ itemData.name }}{{ itemData.version }}版本</div>
      <a :href="itemData.filePath" class="dow-btn">下载到电脑</a>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: "DownLoad",
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showDialog: {
      get() {
        return this.dialogVisible;
      },
      set(val) {
        this.$emit("update:dialogVisible", val);
      },
    },
  },
  data() {
    return {
      itemData: {},
    };
  },
  methods: {
    parentHandleclick(val) {
      this.itemData = { ...val };
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .el-dialog {
  border-radius: 10px;
  .dialog-conainer {
    .dialog-top {
      margin-top: -40px;
      position: relative;
      .title {
        font-size: 24px;
        color: #333333;
      }
      .image-box {
        position: absolute;
        top: -4px;
        right: 0;
        cursor: pointer;
        .image {
          width: 40px;
          height: 40px;
        }
      }
    }
    .qr-image {
      padding-top: 30px;
      position: relative;
      .image {
        margin: 0 auto;
        width: 200px;
        height: 200px;
      }
    }
    .desc {
      margin-top: 15px;
      font-size: 18px;
      color: #999999;
    }
    .dow-btn {
      margin: 30px auto 0;
      width: 160px;
      cursor: pointer;
      height: 50px;
      line-height: 50px;
      border-radius: 25px;
      border: 1px solid #999999;
      font-size: 18px;
      display: block;
      text-align: center;
      color: #666666;
      text-decoration: none;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/downmanage/components/downloaddialog.vue